export const buildInfo = {
  name: "earthquake-wave-propagation",
  version: "0.1.0",
  commit: "af4465d",
  branch: "main",
  repositoryUrl: "https://github.com/baditaflorin/earthquake-wave-propagation",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
  pagesUrl: "https://baditaflorin.github.io/earthquake-wave-propagation/",
} as const;
